// extracted by mini-css-extract-plugin
export default {"menu":"products_menu__ohwkl","search":"products_search__6VQnB"};